import { CheckCircle, XCircle } from '@phosphor-icons/react';
import {
  ButtonSelect,
  CardPlanContainer,
  FunctionalityContent,
  HeaderCard,
  ListFunctionalitiesContent,
  PriceContent,
} from './styles';
import { useHistory } from 'react-router-dom';

export function CardPlanFree() {
  const router = useHistory();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '0px',
      }}
    >
      <CardPlanContainer
        className={`${window.screen.width <= 1100 && 'keen-slider__slide '}`}
      >
        <HeaderCard>
          <h3>iBoxer Free</h3>

          <PriceContent>
            <span>R$</span>
            <strong>0,00</strong>{' '}
          </PriceContent>
          <span>plano gratuito</span>
        </HeaderCard>
        <ListFunctionalitiesContent style={{ marginTop: '1rem' }}>
          <li>
            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Análise detalhada de ativos</strong>
            </FunctionalityContent>
            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Controle de renda passiva</strong>
            </FunctionalityContent>
            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Acesso à comunidade</strong>
            </FunctionalityContent>
            <FunctionalityContent disabled={false}>
              <CheckCircle weight="bold" />
              <strong>Acesso aos simuladores de juros</strong>
            </FunctionalityContent>

            <FunctionalityContent disabled={true}>
              <XCircle weight="bold" />
              <strong>Acesso à carteira inteligente</strong>
            </FunctionalityContent>
            <FunctionalityContent disabled={true}>
              <XCircle weight="bold" />
              <strong>Acesso à área educacional</strong>
            </FunctionalityContent>
            <FunctionalityContent disabled={true}>
              <XCircle weight="bold" />
              <strong>Funcionalidade de imposto de renda</strong>
            </FunctionalityContent>
          </li>
        </ListFunctionalitiesContent>
        <ButtonSelect
          onClick={() => {
            router.push('dashboard');
          }}
        >
          CONTINUAR FREE
        </ButtonSelect>
      </CardPlanContainer>
    </div>
  );
}
